import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-item accordion-layout" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_5 = ["disabled", "id"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["src"]

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useFilterStore } from '@/stores/HomeFilterStore'
import MsButton from '@/components/general/buttons/MsButton.vue'
import DAS from './DAS.vue'
import DoB from './DoB.vue'
import DTS from './DTS.vue'
import Vesseltraffic from './Vesseltraffic.vue'
import lock from '@/assets/svg/lock-gray.svg'
import arrow from '@/assets/svg/arrow.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownToggleTemplate',
  props: {
  title: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props

const filterStore = useFilterStore()

const filterName = ref('filter-' + props.title.replace(/ /g, ''))
const accordionInnerId = ref('accordion-filter-' + props.title.replace(/ /g, ''))
const accordionOuterId = ref('dropdown-filter-' + props.title.replace(/ /g, ''))

const isActive = computed({
  get() {
    if (props.disabled) {
      return false
    }

    if (props.title === 'DTS') {
      return filterStore.isDTSActive
    } else if (props.title === 'DoB') {
      return filterStore.isDoBActive
    } else if (props.title === 'DAS') {
      return filterStore.isDASActive
    } else if (props.title === 'Vessel traffic') {
      return filterStore.isVesselActive
    }
    return false
  },
  set() {
    if (props.title === 'DTS') {
      filterStore.setDTS()
    } else if (props.title === 'DoB') {
      filterStore.setDoB()
    } else if (props.title === 'DAS') {
      filterStore.setDAS()
    } else if (props.title === 'Vessel traffic') {
      filterStore.setVessel()
    }
  }
})

const isExpanded = ref(false)

const updateExpandedState = (expanded: boolean) => {
  isExpanded.value = expanded
}

onMounted(() => {
  const element = document.getElementById(accordionInnerId.value)
  if (element) {
    element.addEventListener('show.bs.collapse', () => updateExpandedState(true))
    element.addEventListener('hide.bs.collapse', () => updateExpandedState(false))
  }
})

onBeforeUnmount(() => {
  const element = document.getElementById(accordionInnerId.value)
  if (element) {
    element.removeEventListener('show.bs.collapse', () => updateExpandedState(true))
    element.removeEventListener('hide.bs.collapse', () => updateExpandedState(false))
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    id: accordionOuterId.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            role: "switch",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isActive).value = $event)),
            disabled: __props.disabled,
            id: filterName.value
          }, null, 8, _hoisted_5), [
            [_vModelCheckbox, isActive.value]
          ]),
          _createElementVNode("label", {
            class: "form-check-label NKT-P1",
            for: filterName.value
          }, _toDisplayString(__props.title), 9, _hoisted_6)
        ]),
        _createElementVNode("div", null, [
          _createVNode(MsButton, {
            disabled: __props.disabled,
            "data-bs-toggle": "collapse",
            "data-bs-target": '#' + accordionInnerId.value,
            "aria-expanded": "false",
            "aria-controls": accordionInnerId.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: __props.disabled ? _unref(lock) : _unref(arrow),
                class: _normalizeClass([{ rotated: isExpanded.value && !__props.disabled }, "icon"])
              }, null, 10, _hoisted_7)
            ]),
            _: 1
          }, 8, ["disabled", "data-bs-target", "aria-controls"])
        ])
      ]),
      (__props.title === 'DAS')
        ? (_openBlock(), _createBlock(DAS, {
            key: 0,
            "accordion-inner-id": accordionInnerId.value,
            "accordion-outer-id": accordionOuterId.value
          }, null, 8, ["accordion-inner-id", "accordion-outer-id"]))
        : _createCommentVNode("", true),
      (__props.title === 'DoB')
        ? (_openBlock(), _createBlock(DoB, {
            key: 1,
            "accordion-inner-id": accordionInnerId.value,
            "accordion-outer-id": accordionOuterId.value
          }, null, 8, ["accordion-inner-id", "accordion-outer-id"]))
        : _createCommentVNode("", true),
      (__props.title === 'DTS')
        ? (_openBlock(), _createBlock(DTS, {
            key: 2,
            "accordion-inner-id": accordionInnerId.value,
            "accordion-outer-id": accordionOuterId.value
          }, null, 8, ["accordion-inner-id", "accordion-outer-id"]))
        : _createCommentVNode("", true),
      (__props.title === 'Vessel traffic')
        ? (_openBlock(), _createBlock(Vesseltraffic, {
            key: 3,
            "accordion-inner-id": accordionInnerId.value,
            "accordion-outer-id": accordionOuterId.value
          }, null, 8, ["accordion-inner-id", "accordion-outer-id"]))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}
}

})